import EditCalendarIcon from '@mui/icons-material/EditCalendar';

import useReportParameters from '../../../../../hooks/providers/useReportParameters';
import Button from '../../../../form/buttons/Button/Button';

const PlannedUpdateButton = () => {
  const {setIsPlannedUpdateModalOpen, areAllSourcesConnected} = useReportParameters();

  const onPlanUpdateButtonClick = e => {
    e.stopPropagation();
    setIsPlannedUpdateModalOpen(true);
  };

  return (
    <Button
      disabled={!areAllSourcesConnected}
      startIcon={
        <EditCalendarIcon
          sx={{
            fontSize: '14px !important'
          }}
        />
      }
      variant="contained"
      size="small"
      onClick={onPlanUpdateButtonClick}
      sx={{
        fontSize: {
          xs: 10,
          sm: 12
        }
      }}
    >
      Planifier
    </Button>
  );
};

export default PlannedUpdateButton;
